import React from 'react';
import { Box } from '@cp/ds/src/components/box';
import { useTheme } from '@cp/ds/src/hooks/useTheme';
import { Button } from '@cp/ds/src/components/button';
import { Typography } from '@cp/ds/src/components/typography';
import { keyframes } from '@mui/system';

const PULSE = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.2;
  }
  100% {
    opacity: 1;
  }
`;

const StopRecordingButton: React.FC<{ onClick: () => void }> = ({ onClick }) => {
  const theme = useTheme();

  return (
    <>
      <Button onClick={onClick} sx={{ width: 'fit-content', mt: 4.375 }}>
        Завершить
      </Button>
      <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.75, mb: { md: 7.25 } }}>
        <Box
          sx={{
            width: 12,
            height: 12,
            borderRadius: '50%',
            backgroundColor: theme.palette['brand pink hover'],
            mr: 1,
            animation: `${PULSE} 1s ${theme.transitions.easing.easeInOut} infinite`,
          }}
        />
        <Typography>Идет запись 00:05</Typography>
      </Box>
    </>
  );
};

export default StopRecordingButton;
